import { atom } from "jotai";

export const balanceLeadSentAt = atom<Date | null>(null);
